export const kitchenData = [{
        "id": "1",
        "product": "Kitchen",
        "image": "/assets/Kitchen/1.jpg",
        "type": "Blender",
        "brand": "Vitamix",
        "model": "PowerBlend 5000",
        "price": "249.99",
        "category": "Appliances",
        "description": "A powerful blender for smoothies, soups, and more, with variable speed control."
    },
    {
        "id": "2",
        "product": "Kitchen",
        "image": "/assets/Kitchen/2.jpg",
        "type": "Cookware Set",
        "brand": "Calphalon",
        "model": "Classic Nonstick",
        "price": "299.00",
        "category": "Cookware",
        "description": "A comprehensive cookware set featuring nonstick surfaces and durable construction."
    },
    {
        "id": "3",
        "product": "Kitchen",
        "image": "/assets/Kitchen/3.jpg",
        "type": "Coffee Maker",
        "brand": "Keurig",
        "model": "K-Elite",
        "price": "149.50",
        "category": "Appliances",
        "description": "A versatile coffee maker with multiple brew sizes and strong brew option."
    },
    {
        "id": "4",
        "product": "Kitchen",
        "image": "/assets/Kitchen/4.jpg",
        "type": "Knife Set",
        "brand": "Wusthof",
        "model": "Classic Knife Block",
        "price": "199.99",
        "category": "Cutlery",
        "description": "A high-quality knife set featuring essential knives and a stylish knife block."
    },
    {
        "id": "5",
        "product": "Kitchen",
        "image": "/assets/Kitchen/5.jpg",
        "type": "Stand Mixer",
        "brand": "KitchenAid",
        "model": "Artisan Series",
        "price": "299.00",
        "category": "Appliances",
        "description": "An iconic stand mixer known for its versatility and wide range of attachments."
    },
    {
        "id": "6",
        "product": "Kitchen",
        "image": "/assets/Kitchen/6.png",
        "type": "Baking Set",
        "brand": "Pyrex",
        "model": "Bake & Store",
        "price": "49.99",
        "category": "Bakeware",
        "description": "A practical baking set with various glass containers for baking, storing, and serving."
    },
    {
        "id": "7",
        "product": "Kitchen",
        "image": "/assets/Kitchen/7.jpg",
        "type": "Rice Cooker",
        "brand": "Zojirushi",
        "model": "Neuro Fuzzy",
        "price": "119.00",
        "category": "Appliances",
        "description": "A sophisticated rice cooker with advanced fuzzy logic technology for perfect rice every time."
    },
    {
        "id": "8",
        "product": "Kitchen",
        "image": "/assets/Kitchen/8.jpg",
        "type": "Utensil Set",
        "brand": "OXO",
        "model": "Good Grips",
        "price": "29.99",
        "category": "Utensils",
        "description": "A versatile utensil set with comfortable grips and a variety of kitchen tools."
    },
    {
        "id": "9",
        "product": "Kitchen",
        "image": "/assets/Kitchen/9.jpg",
        "type": "Food Processor",
        "brand": "Cuisinart",
        "model": "DLC-8SBCY",
        "price": "129.99",
        "category": "Appliances",
        "description": "A powerful food processor for chopping, slicing, and shredding ingredients."
    },
    {
        "id": "10",
        "product": "Kitchen",
        "image": "/assets/Kitchen/10.jpg",
        "type": "Mixer",
        "brand": "OXO",
        "model": "Handheld Mixer",
        "price": "49.50",
        "category": "Appliances",
        "description": "A handheld mixer with multiple speed settings for blending, whipping, and mixing."
    },
    {
        "id": "11",
        "product": "Kitchen",
        "image": "/assets/Kitchen/11.jpg",
        "type": "Dish Set",
        "brand": "Corelle",
        "model": "Classic Winter Frost",
        "price": "69.99",
        "category": "Dining",
        "description": "A durable and lightweight dish set suitable for everyday dining and special occasions."
    },
    {
        "id": "12",
        "product": "Kitchen",
        "image": "/assets/Kitchen/12.jpg",
        "type": "Slow Cooker",
        "brand": "Crock-Pot",
        "model": "Programmable Slow Cooker",
        "price": "79.00",
        "category": "Appliances",
        "description": "A programmable slow cooker for convenient and flavorful cooking."
    }
]